<template>
  <v-container fluid fill-height pa-0>
    <v-layout column fill-height style="position: relative; height: 100%; width: 100%" ma-0 pa-0>
      <v-layout column  ma-0 pa-0>
        <v-flex v-if="getMode == 'inventory'" pa-2>
          <v-layout justify-space-between pa-0 ma-0>
            <component
              is="device-card"
              :data="getActive"
              :selected="getActive"
              :side="'front'"
            />
            <component
              is="device-card"
              :data="getActive"
              :selected="getActive"
              :side="'rear'"
            />
          </v-layout>
        </v-flex>

        <v-layout v-if="getMode == 'inventory'" justify-start align-start pa-0>
          <v-flex xs6 v-if="getFields">
            <v-layout column fill-height v-if="getFields" justify-start px-0>
                <v-layout v-for="(field, name) in getFields" :key="'text' + name" v-if="field.value && (field.type == 'text' || field.type == 'integer') && field.place == 'main'" pt-1>
                  <v-flex xs4 v-if="field.value && field.show" shrink px-0 pb-2>                       
                    <v-text-field
                      :value="$t(field.name)"
                      light
                      auto-grow
                      single-line
                      flat
                      readonly
                      disabled
                      class="white"
                      persistent-hint
                      hide-details
                      :label="$t(field.name)"
                      :rows="1"
                      color="grey"
                    >                   
                    </v-text-field>
                  </v-flex>

                  <v-flex xs8 v-if="field.value && field.show" shrink px-0 pb-2>                          
                    <v-text-field
                      :value="$t(field.value)"
                      light
                      auto-grow
                      single-line
                      flat
                      readonly
                      disabled
                      class="white"
                      persistent-hint
                      hide-details
                      :label="$t(field.name)"
                      :rows="1"
                      color="accent"
                    >                     
                    </v-text-field>
                  </v-flex>
                </v-layout>
            </v-layout>
          </v-flex>

          <v-flex xs6 v-if="getFields" >
            <v-layout column v-if="getFields" justify-start pl-2>
              <v-layout v-for="(field, name) in getFields" :key= " 'select' + name" v-if="field.value && field.type == 'select' && field.place == 'main'" pt-1>
                <v-flex xs4 v-if="field.value && field.show" shrink px-0 pb-2>                       
                    <v-text-field
                      :value="$t(field.name)"
                      light
                      auto-grow
                      single-line
                      flat
                      readonly
                      disabled
                      class="white"
                      persistent-hint
                      hide-details
                      :label="$t(field.name)"
                      :rows="1"
                      color="grey"
                    >                   
                    </v-text-field>
                  </v-flex>

                  <v-flex xs8 v-if="field.value && field.show" shrink px-0 pb-2>                          
                    <v-text-field
                      :value="$t(field.value)"
                      light
                      auto-grow
                      single-line
                      flat
                      readonly
                      disabled
                      class="white"
                      persistent-hint
                      hide-details
                      :label="$t(field.name)"
                      :rows="1"
                      color="accent"
                    >                     
                    </v-text-field>
                  </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-layout>

      <v-layout column fill-height ref="plain" ma-0 pt-1>
        <v-layout class="backgrey" justify-space-between align-center style="height: 44px" py-0 px-2>
          <v-toolbar-title class="subtitle-2 text-uppercase" >
            <span class="body-2 text-uppercase">{{ $t('device structure') }}</span>
          </v-toolbar-title>
        </v-layout>

        <div v-if="treeshow" ref="equipment_tree_wrapper" pr-2 style="position: relative; height: 100%; width: 100%;">
          <equipment-tree
            :nodes="getNodes"
            :mode="getMode"
            @selected="(payload) => onSelected(payload)"
            @showTree="treeshow = !treeshow"
            @add="(payload) => onAdd(payload)"
            @edit="(payload) => onConfigurationEdit(payload)"
            @inventory="(payload) => onInventory(payload)"
            @remove="(payload) => onRemove(payload)"
          />

          <equipment-tree-bar
            :open="getTreeBarOpen"
            :data="getSelectedObj"
            :selectedMeta="getSelectedMeta"
            :template="getTemplate"
            :cabinet="cabinet"
            :closedUnits="closedUnits"
            @loadDevice="loadDevice"
            @polling="() => initPolling()"
            @add="(payload) => onAdd(payload)"
            @update="(payload) => {$emit('update', payload)}"
            @deviceReplacingLoadDevices="() => {$emit('deviceReplacingLoadDevices')}"
            @configurationEdit="(payload) => onConfigurationEdit(payload)"
            @inventory="(payload) => onInventory(payload)"
            @remove="(payload) => onRemove(payload)"
            @close="() => onBarClose()"
          />
        </div>

        <v-dialog v-model="dialog.chart.open" max-width="50%" v-if="!editable && dialog.chart.open">
            <chart-card
              v-if="dialog.chart.open"
              :data="measure"
              :equipment="getSelectedObj"
              @close="() => {
                dialog.chart.open = false
              }"
            />
        </v-dialog>

        <v-dialog persistent v-model="dialog.preferences.open" max-width="50%" v-if="!editable && dialog.preferences.open">
            <preferences-card
              v-if="dialog.preferences.open"
              :data="dialog.preferences.param"
              @close="()=>{dialog.preferences.open = false}"
            />
        </v-dialog>
        <!-- Диалог для редактирования сообщений -->
        <v-dialog persistent v-model="dialog.rules.open" max-width="600px" v-if="!editable && dialog.rules.open">
          <rules-table
            :row="dialog.rules.row"
            :ref-id="selected_obj && selected_obj.ref_id"
            @close="() => {dialog.rules.open = false}"
            @updateMeasures="() => {equipmentTableUpdateCounter++}"
            @loadDevice="loadDevice"
            @polling="() => initPolling()"
          />
        </v-dialog>
        <!-- Диалог добавления модулей -->
        <v-dialog persistent v-model="dialog.add.open" max-width="50%" v-if="!editable && dialog.add.open">
          <add-card
            v-if="dialog.add.open"
            :data="dialog.add.obj"
            @close="() => {
              dialog.add.open = false
              dialog.add.obj = null
            }"
            @update="() => {
              $emit('update')
              reset()
            }"
          />
        </v-dialog>
        <!-- Диалог редактирования модулей -->
        <v-dialog persistent v-model="dialog.edit.open" max-width="50%" v-if="!editable && dialog.edit.open">
          <module-update-card
            :data="dialog.edit.obj"
            @close="() => {
              dialog.edit.open = false
              dialog.edit.obj = null
            }"
            @update="(payload) => {
              $emit('update', payload)
              reset()
            }"
          />
        </v-dialog>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import equipmentTree from '@/nms/components/equipment/equipment-tree.vue'
import equipmentTreeBar from '@/nms/components/equipment/equipment-tree-bar.vue'
import rulesTable from '@/nms/pages/equipment/rules-table.vue'
import chartCard from '@/nms/pages/equipment/chart-card.vue'
import preferencesCard from '@/nms/pages/equipment/preferences-card.vue'
import addCard from '@/nms/components/equipment/add-card.vue'
import moduleUpdateCard from '@/nms/pages/device/module-update-card.vue'
import DeviceCard from '@/nms/components/device/device-card.vue'

// Типы
interface TreeNode {
  $id?: string
  children?: TreeNode[]
  [key: string]: any
}

interface TemplateData {
  monitoring?: Array<{ id: string }>
  [key: string]: any
}

interface DialogState {
  chart: { open: boolean }
  preferences: { open: boolean; param: any | null }
  rules: { open: boolean; row: any | null }
  add: { open: boolean; obj: any | null }
  edit: { open: boolean; obj: any | null }
}

interface ViewState {
  panel: number
  places: string[]
}

interface BarState {
  open: boolean
}

interface CurrentState {
  side: string
  template: any | null
  parent: any | null
}

interface EquipmentData {
  $id?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'EQUIPMENT_MEASURES',

  components: {
    equipmentTree,
    equipmentTreeBar,
    chartCard,
    preferencesCard,
    rulesTable,
    addCard,
    moduleUpdateCard,
    DeviceCard,
  },

  props: {
    mode: {
      type: String,
      default: () => 'inventory'
    },
    nodes: {
      type: Array as () => TreeNode[],
      default: () => []
    },
    data: {
      type: Object as () => EquipmentData,
      default: () => ({})
    },
    cabinet: {
      type: Object as () => EquipmentData,
      default: () => ({})
    },
    closedUnits: {
      type: Array as () => any[],
      default: () => []
    },
    editable: {
      type: Boolean,
      default: () => false
    },
    fields: {
      type: Object as () => Record<string, any>,
      default: () => ({})
    },
    model: {
      type: Object as () => Record<string, any>,
      default: () => ({})
    },
  },

  data(): {
    bar: BarState
    inventory_bar_size: number
    inventoryBarOpen: boolean
    treeshow: boolean
    selected: string | null
    selected_obj: any | null
    selected_meta: any | null
    template: TemplateData
    statuses: Record<string, string>
    view: ViewState
    dialog: DialogState
    equipmentTableUpdateCounter: number
    measure: any | null
    dashboards: any[]
  } {
    return {
      bar: { open: false },
      inventory_bar_size: 1000,
      inventoryBarOpen: false,
      treeshow: true,
      selected: null,
      selected_obj: null,
      selected_meta: null,
      template: {},
      statuses: {},
      view: {
        panel: 0,
        places: ['configuration', 'params', 'console', 'manage', 'vinteo'],
      },
      dialog: {
        chart: { open: false },
        preferences: { open: false, param: null },
        rules: { open: false, row: null },
        add: { open: false, obj: null },
        edit: { open: false, obj: null },
      },
      equipmentTableUpdateCounter: 0,
      measure: null,
      dashboards: [],
    }
  },

  computed: {
    getData(): EquipmentData {
      return this.data
    },
    getFields(): Record<string, any> {
      return this.fields
    },
    getMode(): string {
      return this.mode
    },
    getSelected(): string | null {
      return this.selected ? this.selected : (this.data.$id || null)
    },
    getSelectedObj(): any {
      return this.selected_obj ? this.selected_obj : this.data
    },
    getSelectedMeta(): any {
      return this.selected_meta
    },
    getTemplate(): TemplateData {
      return this.template
    },
    getNodes(): TreeNode[] {
      return this.nodes
    },
    getTreeBarOpen(): boolean {
      return this.bar.open
    },
    getActive(): any {
      return this.$store.state.devices.activeDevice
    },
  },

  watch: {
    selected: {
      handler(newVal: string | null): void {
        if (!newVal) {
          this.selected_obj = null
          this.selected_meta = null
        }
      },
      deep: true
    },
    nodes: {
      handler(newVal: TreeNode[]): void {
        // console.log('WATCH', this.$options.name, 'nodes JSON', JSON.parse(JSON.stringify(newVal)))
        if (newVal && Array.isArray(newVal) && newVal.length) {
          this.setup('watch nodes')
        }
      },
      deep: true
    },
  },

  beforeDestroy(): void {
    this.statusUnsubscribe('EQUIPMENT_MEASURES_NODES')
  },

  methods: {
    async setup(caller: string): Promise<void> {
      console.log(this.$options.name, 'setup', 'caller', caller)
      this.reset()
      await this.loadDevice('setup')
      if (this.mode === 'monitoring') {
        this.getDashboards('setup')
        this.loadMirrors('setup')
      }
    },

    getDashboards(caller: string): void {
      // const anchors = this.getSelectedObj.anchors ? this.getSelectedObj.anchors.split(','): undefined;
      // if (anchors) fetchDashboards(anchors).then((res) => { this.dashboards = res; });
      // else this.dashboards = [];
      // this.dashboards = [];
    },

    async loadMirrors(caller: string): Promise<void> {
      console.log(this.$options.name, 'loadMirrors', 'caller', caller)
      if (this.nodes) {
        await this.statusUnsubscribe('EQUIPMENT_MEASURES_NODES')
        this.statusSubscribe(this.nodes, 'form_device_bar_nodes')
        this.statuses = {}
        this.getMirror(this.nodes)
      }
    },

    async getMirror(arr: TreeNode[]): Promise<void> {
      try {
        for (const item of arr) {
          const mirror$ = await item.getMirror?.()
          if (mirror$) {
            if (mirror$.state) {
              this.$set(this.statuses, item.$id, mirror$.state.infoState)
            } else {
              this.$set(this.statuses, item.$id, 'no status')
            }
          }
          if (item.children?.length) {
            await this.getMirror(item.children)
          }
        }
      } catch (error) {
        console.error(this.$options.name, 'getMirror', 'error', error)
      }
    },

    async loadDevice(caller: string): Promise<void> {
      console.log(this.$options.name, 'loadDevice', 'caller', caller)
      try {
        const query = {
          id: [this.getSelected],
          notNull: true,
          data: {
            namePath: true,
            children: {
              data: {
                children: {
                  data: {
                    children: true,
                    namePath: true,
                  },
                },
                namePath: true,
              },
            },
          },
        }
        let co$ = await this.$bridge.cmdbQuery(query)
        let device$
        if (co$ && !Array.isArray(co$)) {
          device$ = co$
        }
        if (co$ && Array.isArray(co$)) {
          device$ = co$[0]
        }
        if (device$) {
          this.selected_meta = await device$.meta()
          const template$ = await this.$bridge.getTemplates(device$.cls, { id: device$.template })
          this.template = template$[0]
          console.log(this.$options.name, 'loadDevice', 'template', this.template)
          this.selected_obj = device$
          console.log(this.$options.name, 'loadDevice', 'meta', this.selected_meta)
          console.log(this.$options.name, 'loadDevice', 'selected_obj', this.selected_obj)
          if (this.mode === 'monitoring') {
            this.getDashboards('loadDevice')
            if (this.template?.monitoring) {
              this.addPlaces(this.template.monitoring)
            }
          }
        }
      } catch (error) {
        console.error(this.$options.name, 'loadDevice', 'error', error)
      }
    },

    addPlaces(arr: Array<{ id: string }>): void {
      arr.forEach(obj => {
        if (!this.$store.getters.getEquipmentNails.measures.view.places.includes(obj.id)) {
          this.$store.getters.getEquipmentNails.measures.view.places.push(obj.id)
        }
      })
      console.log(this.$options.name, 'addPlaces', 'places', this.$store.getters.getEquipmentNails.measures.view.places)
    },

    onBarClose(): void {
      this.$set(this.bar, 'open', false)
      this.selected = null
      this.selected_obj = null
      this.selected_meta = null
    },

    async onSelected(payload: any): Promise<void> {
      console.log(this.$options.name, 'onSelected', payload)
      try {
        if (payload) {
          if (this.selected === payload.$id) return
          this.$set(this.bar, 'open', true)
          this.selected_obj = payload
          this.selected = payload.$id
          await this.loadDevice('onSelected')
        } else {
          this.selected = null
          this.selected_obj = null
          this.selected_meta = null
          this.$set(this.bar, 'open', false)
        }
        this.$emit('selected', payload)
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    onAdd(val: any): void {
      console.log(this.$options.name, 'onAdd', val)
      if (!val) return
      this.$set(this.dialog.add, 'obj', val)
      this.$set(this.dialog.add, 'open', true)
    },

    onInventory(val: any): void {
      console.log(this.$options.name, 'onInventory', val)
      this.$emit('inventory', val)
    },

    onConfigurationEdit(val: any): void {
      if (!val) return
      this.$set(this.dialog.edit, 'obj', val)
      this.$set(this.dialog.edit, 'open', true)
    },

    onRemove(val: any): void {
      if (val?.cls === 'slot') return
      console.log(this.$options.name, 'onRemove', val)
      this.$dialog.confirm({
        text: 'Удалить ' + val.name + '?',
        title: 'Удаление',
        actions: {
          false: 'Отмена',
          true: {
            color: 'red',
            text: 'Удалить',
            handle: async () => {
              try {
                const obj$ = await this.$bridge.getObjectById(val.$id)
                const parent = await obj$.getParent()
                if (obj$) {
                  const d = await obj$.delete()
                  console.log(this.$options.name, 'onDelete', 'd', d)
                  if (d) {
                    this.$dialog.notify.success(`Успешно удалёно`, {
                      timeout: 5000
                    })
                    console.log(this.$options.name, 'onDelete', 'parent', parent)
                    await this.$store.dispatch('loadChildren', parent)
                    await this.$store.dispatch('activeTree', parent)
                    this.$emit('update', parent)
                    this.$set(this.bar, 'open', false)
                  }
                  else {
                    this.$dialog.notify.error('Ошибка удаления', { timeout: 5000 })
                    return
                  }
                }
              } catch (err) {
                console.error('onDelete', val, 'SMTH WRONG', err)
                this.$errorHandler(err)
              }
            }
          }
        }
      })
    },

    reset(): void {
      this.inventoryBarOpen = false
      this.openInventoryBar(false)
      this.selected = null
      this.selected_obj = null
      this.selected_meta = null
      this.template = {}
      this.statuses = {}
      this.dialog = {
        chart: { open: false },
        preferences: { open: false, param: null },
        rules: { open: false, row: null },
        add: { open: false, obj: null },
        edit: { open: false, obj: null },
      }
      this.equipmentTableUpdateCounter = 0
      this.measure = null
    },

    openInventoryBar(val: boolean): void {
      const wrapper = this.$refs['inventory_bar_wrapper'] as HTMLElement
      if (wrapper) {
        this.inventory_bar_size = wrapper.clientWidth
        this.inventoryBarOpen = val
      }
    },

    async initPolling(): Promise<void> {
      console.log(this.$options.name, 'initPolling', 'this.getSelectedObj', this.getSelectedObj)
      try {
        let parentToUpdateId = await this.$bridge.customQuery('alarm', 'data_book/parentForPulling', {id:this.getSelectedObj.$id}, 'get')
        // console.log(this.$options.name, 'initPolling', 'parentToUpdateId', parentToUpdateId)
        if(parentToUpdateId) {
          let parentToUpdate = await this.$bridge.getObjectById(parentToUpdateId)
          // console.log(this.$options.name, 'initPolling', 'parentToUpdate', parentToUpdate)
          const u = await parentToUpdate.initPolling?.()
          // const u = await this.getSelectedObj.initPolling?.()
          if (u) {
            console.log(this.$options.name, 'initPolling', 'SUCCESS', u)
          } else {
            console.log(this.$options.name, 'initPolling', 'WRONG', u)
          }
        }
      } catch (err) {
        console.error(this.$options.name, 'initPolling', 'WRONG', err)
        this.$errorHandler(err)
      }
    },

    async statusSubscribe(arr: TreeNode[], group: string): Promise<void> {
      console.log(this.$options.name, 'statusSubscribe', 'arr', arr)
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: group,
        listener: 'status'
      })

      const makeHeap = (array: TreeNode[]): TreeNode[] => {
        const heap: TreeNode[] = []
        const traverse = (arr: TreeNode[]) => {
          arr.forEach((item) => {
            heap.push(item)
            if (item.children) {
              traverse(item.children)
            }
          })
        }
        traverse(array)
        return heap
      }

      const arr_ = makeHeap(arr)
      console.log(this.$options.name, 'statusSubscribe', 'arr_heap', arr_)
      if (arr_.length) {
        arr_.forEach((item: TreeNode) => {
          if (item.$id) {
            this.$store.dispatch('addStatusKey', item)
          }
        })
        await this.$bridge.subscribe(arr_.map(obj => obj.$id))
      }
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe(group: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },
  },
})
</script>

<style lang="css" scoped>

</style>
